module.exports = __webpack_public_path__ + "img/IMÁGENES CLÍNICAS KC7 2.18aefd98.png";